<div style="height: 560px;">
  <form [formGroup]="SettingsForm">
    <div class="mb-3 row" style="margin-bottom: 0px;">
      <fieldset>
        <legend>Basic Settings</legend>
      </fieldset>
    </div>
    <div class="mb-3">
    </div>
    <div class="row">
      <div class="col-lg-1">
        <span>Name:</span>
      </div>
      <div class="col-lg-4">
        <input type="text" pInputText style="width: 250px;" [formControl]="name" />
      </div>
      <div class="col-lg-2">
        <input type="checkbox" [formControl]="enabled" />
        <span class="uv-checkbox-label">Enabled</span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-1">
        <span>&nbsp;</span>
      </div>
      <div class="col-lg-4">
        @if (name.hasError('required')) {
          <div class="alert alert-danger ms-0 me-0" style="width: 250px;">
            This value is required
          </div>
        }
      </div>
    </div>
    <div class="mb-3"></div>
    <div class="mb-3 row">
      <div class="col-lg-1">
        <span>&nbsp;</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="captureStartup" />
        <span class="uv-checkbox-label">Capture Startup Config</span>
      </div>
      <div class="col-lg-1">
        <span>&nbsp;</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="captureSyslog" />
        <span class="uv-checkbox-label">Capture Syslog</span>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-1">
        <span>&nbsp;</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="captureRunning" />
        <span class="uv-checkbox-label">Capture Running Config</span>
      </div>
    </div>
    <div class="mb-3 row">
    </div>
    <div class="mb-3 row">
      <div class="col-lg-1">
        <span>&nbsp;</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="captureCustom" />
        <span class="uv-checkbox-label">Capture/Execute Custom Script</span>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-1">
        <span>&nbsp;</span>
      </div>
      <span class="col-lg-1">Custom Script:</span>
      <div class="col-lg-4">
        <textarea [formControl]="customScript" rows="5" cols="100" placeholder="Add the custom script here"></textarea>
      </div>
    </div>
    @if (SettingsForm.hasError('atLeastOneConfigSelected')) {
      <div class="mb-3 row">
        <div class="col-lg-1">
          <span>&nbsp;</span>
        </div>
        <div class="col-lg-4 alert alert-danger">At least one configuration must be captured</div>
      </div>
    }
    <div class="row">
      <div class="col-lg-1">
        <span>&nbsp;</span>
      </div>
      <div class="col-lg-6">
        Keep the last &nbsp; <input type="number" pInputText style="width: 70px;" [formControl]="keep" /> &nbsp; configuration capture results.
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="keepCommandPrompt" />
        <span class="uv-checkbox-label">Keep Command Prompt</span>
      </div>

    </div>
    @if (keep.hasError('required')) {
      <div class="row">
        <div class="col-lg-1">
          <span>&nbsp;</span>
        </div>
        <div class="col-lg-4 alert alert-danger mb-0">This value is required</div>
      </div>
    }
    @if (keep.hasError('minValue') || keep.hasError('maxValue')) {
      <div class="row">
        <div class="col-lg-1">
          <span>&nbsp;</span>
        </div>
        <div class="col-lg-4 alert alert-danger mb-0">This value must be in the range 1 - 99</div>
      </div>
    }
    <div class="mb-3"></div>
    <div class="row">
      <fieldset>
        <legend>Config Export Settings</legend>
      </fieldset>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-12" style="height: 5px;">
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-2">
        <span>Captured Config Folder:</span>
      </div>
      <div class="col-lg-7">
        <input type="text" pInputText style="width: 100%;" [formControl]="configExportFolder" />
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-lg-2">
        <span>&nbsp;</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="createDateSubfolder" />
        <span class="uv-checkbox-label">Create Date Subfolder</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="createDeviceSubfolder" />
        <span class="uv-checkbox-label">Create Device Subfolder</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="saveChangesOnly" />
        <span class="uv-checkbox-label">Save Changes Only</span>
      </div>
      <div class="col-lg-3">
        <input type="checkbox" [formControl]="exportToServer" />
        <span class="uv-checkbox-label">Export Configs To Server</span>
      </div>
    </div>
  </form>
</div>
